import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3087ac34")

_pushScopeId("data-v-3087ac34")
const _hoisted_1 = { class: "ctrl-buttons" }
const _hoisted_2 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("dig-ui-show-button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo(`/users/${$props.user?.id}`))),
          class: "icon-button"
        }),
        ($setup.isAdmin)
          ? (_openBlock(), _createBlock("dig-ui-delete-button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleDelete())),
              title: $setup.t('Tooltips.deleteSimulation'),
              class: "icon-button"
            }, null, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_2, [
        _createVNode("span", {
          class: "go-to",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goTo(`/users/${$props.user?.id}`)))
        }, _toDisplayString($props.user?.username) + " - " + _toDisplayString($props.user?.email) + " - " + _toDisplayString($setup.t(`Role.${$props.user?.role}`)), 1)
      ])
    ]),
    _: 1
  }))
})